import React from 'react';
import { Link } from 'react-router-dom';
import siteContent from '../../content/site/content.json';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';

const FeaturePreviewSection = () => {
  const d = siteContent.featurePreview;
  if (!d) return null;

  return (
    <section id="feature-preview" className="py-16 lg:py-20 bg-white" data-testid="feature-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1F1E1E] leading-tight mb-3">{d.heading}</h2>
          <p className="text-base text-[#3B3535]/70 leading-relaxed">{d.description}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {(d.items || []).map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <div key={item.title} className="rounded-2xl p-5 border border-gray-100 bg-[#FFFAF8] hover:shadow-md transition-shadow" data-testid={`feature-preview-${i}`}>
                <Icon className="w-6 h-6 text-[#B5541B] mb-3" />
                <h3 className="font-bold text-[#1F1E1E] text-sm mb-1.5">{item.title}</h3>
                <p className="text-xs text-[#3B3535]/70 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
        {d.ctaLabel && (
          <div className="mt-8">
            <Link
              to={d.ctaHref || '/features'}
              data-testid="feature-preview-cta"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#B5541B] hover:text-[#8B3F14] transition-colors group"
            >
              {d.ctaLabel}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturePreviewSection;
